
import { ChannelRegionsType } from '@app/analyze-data/types/channel-options.type';
import { CountryAndLanguage } from '@app/core/models/types/country-and-language.type';

export const COLUMN_STATS_EMPTY: string = '(Blank)';

export type CountryDropdownOption = ChannelRegionsType & CountryAndLanguage & {
    displayLanguage: boolean;
};

export enum ColumnStatsAccordionItem {
    Uncategorized = 'uncategorized',
    Categorized = 'categorized'
}
